// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lazyLoadObserver":"lazyLoadObserver_j168O","lazyLoadBlock":"lazyLoadBlock_PdWjN"};